import { ScrollView } from 'react-native';
import styled from 'styled-components/native';

export const ContainerWrapper = styled(ScrollView)`
  padding-horizontal: 16px;
`;
